import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'tellent-assistant-brand-mark',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <defs>
      <linearGradient id="tellent-assistant-brand-mark-grad" x1="100%" y1="50%" x2="0%" y2="50%">
        <stop offset="0%" stop-color="#5a1cb7" />
        <stop offset="100%" stop-color="#d91c7a" />
      </linearGradient>
    </defs>
    <path
      fill="url(#tellent-assistant-brand-mark-grad)"
      d="M20.5143 19.3998C20.7753 20.0958 20.0956 20.7755 19.3996 20.5145L12.3039 17.8536C12.1079 17.7801 11.8919 17.7801 11.6959 17.8536L4.60021 20.5145C3.90421 20.7755 3.22454 20.0958 3.48554 19.3998L6.14642 12.3041C6.21992 12.1081 6.21992 11.8921 6.14642 11.6961L3.48554 4.60046C3.22454 3.90446 3.90421 3.22479 4.60021 3.48579L11.6959 6.14667C11.8919 6.22017 12.1079 6.22017 12.3039 6.14667L19.3996 3.48579C20.0956 3.22479 20.7753 3.90446 20.5143 4.60046L17.8534 11.6961C17.7799 11.8921 17.7799 12.1081 17.8534 12.3041L20.5143 19.3998Z"
    />
  </svg>`,
  styleUrls: ['./tellent-assistant-brand-mark.component.less'],
})
export class TellentAssistantBrandMarkComponent {}
